<template>
  <div>
    <modal :opened="modal">
      <modal-menu :menus="menus" :selected="menu" @changeMenu="toggleMenu"/>
      <div class="px-1" v-show="menu === 1">
        <div class="mb-3">
          <label class="d-block font-weight-bold small mb-1">Código do Voucher</label>
          <div class="row no-gutters">
            <div class="col-8 position-relative">
              <span class="font-weight-bold text-nowrap" style="position: absolute; top: 7px; left: 12px">B -</span>
              <input id="voucherInput" placeholder="######" type="tel" class="form-control" @keyup.enter="buscarVoucher(false)" v-model="ref_voucher" :disabled="voucher.id_beneficio" style="padding-left: 38px"/>
            </div>
            <div class="col-4 pl-2">
              <button class="btn btn-primary text-nowrap btn-block" @click="buscarVoucher(false)" :disabled="voucher.id_beneficio || !ref_voucher.trim() || load">
                Pesquisar
              </button>
            </div>
          </div>
        </div>
        <loading v-show="load" class="py-4"/>
        <div v-show="!load">
          <div v-if="voucher.id_voucher">
            <div class="alert alert-info mb-2">
              <h6 class="font-weight-bold mb-1">Voucher válido</h6>
              <div class="small">Atenção, clique em "Validar voucher" para dar baixa.</div>
            </div>
            <div class="small">
              <div><b>Benefício:</b> {{ voucher.titulo }}</div>
              <div><b>Expiração:</b> {{ voucher.data_expiracao }} | <b>Pontos:</b> {{ voucher.pontos }}</div>
              <div><b>Cliente:</b> {{ voucher.nome_cliente }}</div>
              <div><b>Empresa:</b> {{ voucher.nome_fantasia }}</div>
            </div>
          </div>
          <div class="alert alert-warning mb-0" v-if="voucher.msg">
            <h6 class="font-weight-bold mb-1">Erro ao validar</h6>
            <div class="small">{{voucher.msg}}</div>
          </div>
        </div>
        <div class="row no-gutters justify-content-center mt-4 border-top pt-3">
          <div class="col-6 p-1" v-if="!voucher.id_voucher">
            <button class="btn btn-dark btn-block" @click="modal = false">
              Voltar
            </button>
          </div>
          <div class="col-6 p-1" v-if="voucher.id_voucher">
            <button class="btn btn-outline-dark btn-block" @click="cancelarVoucher">
              Cancelar
            </button>
          </div>
          <div class="col-6 p-1" v-if="voucher.id_voucher">
            <button class="btn btn-success btn-block" @click="validarVoucher()" :disabled="load">
              Validar voucher
            </button>
          </div>
        </div>
      </div>
      <div class="px-1" v-show="menu === 2">
        <loading v-if="load" class="pb-4"/>
        <form @submit.prevent="addPontosCliente">
          <div v-show="!load" v-if="!pontos.id_cliente">
            <div class="alert alert-success mb-3" v-if="retornoPontos.id_fidelidade_extrato">
              <h6 class="font-weight-bold mb-1">Adicionado com sucesso!</h6>
              <div class="small">
                <div>Cliente: {{retornoPontos.nome_cliente}} | Novo saldo: {{retornoPontos.saldo}}</div>
                <div>{{retornoPontos.titulo}}</div>
              </div>
            </div>
            <div class="mb-3">
              <label class="d-block font-weight-bold small mb-1">Telefone do Cliente</label>
              <div class="row no-gutters">
                <div class="col-8">
                  <the-mask :mask="['(##) ####-####', '(##) #####-####']" class="form-control" id="clienteInput" placeholder="(##) #####-###" minlength="8"
                            @keyup.enter.native.prevent="buscarCliente()" v-model="ref_cliente" required :disabled="load"/>
                </div>
                <div class="col-4 pl-2">
                  <button type="button" class="btn text-nowrap btn-primary btn-block" @click="buscarCliente()" :disabled="load || ref_cliente.length < 10">
                    Pesquisar
                  </button>
                </div>
              </div>
            </div>
            <div class="height-75" v-if="clientes.length" >
              <table class="table table-hover table-sm small mb-0">
                <tr class="bg-light">
                  <th>Nome</th>
                  <th>&nbsp;</th>
                </tr>
                <tbody>
                  <tr class="pointer" v-for="c in clientes" @click="selecionarCliente(c)">
                    <td class="align-middle">
                      <div class="font-weight-bold">{{ c.nome_cliente }}</div>
                      <div>Telefone: {{ c.telefone | phone }}</div>
                      <div v-if="isNaN(c.email) && c.tipo_cliente !== '3'">Email: {{ c.email }}</div>
                      <div>Pedidos: {{ c.qtd_pedidos || 'Nenhum' }}</div>
                      <div><b>Saldo atual:</b> {{ c.pontos || '0' }} pontos</div>
                    </td>
                    <td class="text-right align-middle"><button type="button" class="btn btn-sm"><i class="fa fa-angle-right"></i></button></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="naoEncontrado">
              <div class="my-3 text-center">
                <h6 class="font-weight-bold mb-0">Cliente não cadastrado</h6>
                <div class="small">Deseja cadastrar este cliente no programa de vantagens?</div>
                <div class="text-center mt-3">
                  <button type="button" class="btn btn-outline-primary" @click="novoCliente()">Cadastrar <i class="fa fa-user-plus ml-1"></i></button>
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters" v-if="pontos.id_cliente" v-show="!load">
            <div class="col-12">
              <div class="alert alert-info">
                <div><b>Novo saldo:</b> <span v-if="pontos.valor_pontos">{{pontos.saldo + parseInt(pontos.valor_pontos)}}</span></div>
                <div class="small">Saldo atual: {{pontos.saldo}}</div>
              </div>
            </div>
            <div class="col-7 pr-2 mb-2">
              <label class="mb-0 font-weight-bold small">Cliente</label>
              <input class="form-control" :value="pontos.nome_cliente" disabled>
            </div>
            <div class="col-md-5 mb-2">
              <label class="mb-0 font-weight-bold small">Pontos *</label>
              <input id="valorPontos" type="number" min="1" placeholder="Ex: 2" class="form-control" v-model="pontos.valor_pontos" required/>
            </div>
            <div class="col-md-12 mb-3">
              <label class="mb-0 font-weight-bold small">Identificador</label>
              <input class="form-control" type="text" v-model="pontos.identificador" placeholder="Ex: Transferência de pontos">
            </div>
          </div>
          <div class="row no-gutters justify-content-center border-top pt-3">
            <div class="col-6 p-1" v-if="!pontos.id_cliente">
              <button type="button" class="btn btn-dark btn-block" @click="modal = false">
                Voltar
              </button>
            </div>
            <div class="col-6 p-1" v-if="pontos.id_cliente">
              <button type="button" class="btn btn-outline-dark btn-block" @click="pontos = {}">
                Cancelar
              </button>
            </div>
            <div class="col-6 p-1" v-if="pontos.id_cliente">
              <button class="btn btn-success btn-block" :disabled="load">
                Adicionar Pontos
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="px-1" v-if="menu === 3">
        <loading v-if="load" class="pb-4"/>
        <form @submit.prevent="addNovoCliente()" v-else>
          <div class="form-group">
            <label class="d-block font-weight-bold small mb-1">Nome completo</label>
            <input type="text" id="nomeCadastro" class="form-control" placeholder="Ex: Lucas Andrade" v-model="cliente.nome_cliente" required minlength="3">
          </div>
          <div class="form-group">
            <label class="d-block font-weight-bold small mb-1">Telefone</label>
            <the-mask :mask="['(##) ####-####', '(##) #####-####']" class="form-control" id="telefoneCadastro" placeholder="(##) #####-###" v-model="cliente.telefone" required/>
          </div>
          <div class="row no-gutters justify-content-center mt-4 border-top pt-3">
            <div class="col-6 p-1">
              <button type="button" class="btn btn-dark btn-block" @click="menu = 2">
                Voltar
              </button>
            </div>
            <div class="col-6 p-1">
              <button class="btn btn-success btn-block" :disabled="load">
                Adicionar Cliente
              </button>
            </div>
          </div>
        </form>
      </div>
    </modal>
  </div>
</template>

<script>
import Loading from "@/components/gestor/loading";
import TopBar from "@/components/commons/TopBar";
import Modal from "@/components/gestor/ModalGestor";
import ModalMenu from "@/components/commons/ModalMenu";

export default {
  name: 'ValidadorVoucher',
  components: {ModalMenu, Modal, Loading, TopBar },
  data() {
    return {
      modal: false,
      load: false,
      token: localStorage.getItem('key'),
      voucher: { msg: null },
      ref_voucher: '',

      menu: 1,
      menus: [
        { nome: 'Validador', active: true },
        { nome: 'Pontuar', active: true }
      ],

      ref_cliente: '',
      clientes: [],
      naoEncontrado: false,
      pontos: {},
      retornoPontos: {},

      cliente: { nome_cliente: '', telefone: '' }
    }
  },

  methods: {
    validarVoucher(text) {
      this.$swal({
        text: text || "Deseja marcar como validado este voucher?",
        buttons: ["Não", "Sim"],
        dangerMode: true
      }).then(res => {
        if (res) {
          this.buscarVoucher(true);
        }
      });
    },

    buscarVoucher(validar) {
      if (this.load) {
        return;
      }

      this.ref_voucher = this.ref_voucher ? this.ref_voucher.replace('B-', '') : '';

      if (!this.ref_voucher.trim() || isNaN(this.ref_voucher)) {
        this.$swal("Por favor informe apenas números no código do Voucher").then(() => {
          this.$helpers.focusElement('voucherInput');
        });

        return;
      }

      this.load = true;
      this.voucher = { msg: null };

      this.$http.post('voucher/validar/' + this.token, { voucher: this.ref_voucher, validar })
        .then(res => {
          this.load = false;

          if (res.data.result) {
            if (validar) {
              this.voucher = { msg: null };
              this.ref_voucher = '';
              this.$swal("Voucher validado com sucesso!");
              return;
            }

            this.voucher = {
              ...res.data.dados,
              msg: res.data.msg
            };

          } else {
            this.voucher.msg = res.data.msg || 'Este Benefício não está mais disponível!'
          }

        }, res => {
          this.load = false;
          this.voucher.msg = res.data.msg || 'Erro temporário'
        });
    },

    cancelarVoucher() {
      this.voucher = {msg: null};
      this.ref_voucher = '';
      this.$nextTick(() => {
        this.$helpers.focusElement('voucherInput');
      })
    },

    buscarCliente() {
      if (this.load || this.ref_cliente.trim().length < 10) {
        return;
      }

      this.load = true;
      this.naoEncontrado = false;
      this.clientes = [];
      this.pontos = {};
      this.retornoPontos = {};

      this.$http.get('fidelidade/cliente/' + this.token, { params: { ref_cliente: this.ref_cliente } })
        .then(res => {
          this.load = false;
          this.clientes = res.data || [];
          this.naoEncontrado = !this.clientes.length

        }, res => {
          this.load = false;
        });
    },

    selecionarCliente(c) {
      this.pontos = {
        id_cliente: c.id_cliente,
        nome_cliente: c.nome_cliente,
        identificador: '',
        valor_pontos: '',
        saldo: parseInt(c.pontos || '0'),
      }

      this.$nextTick(() => {
        this.$helpers.focusElement('valorPontos');
      });
    },

    addPontosCliente() {
      if (this.pontos.id_cliente) {
        if (!this.pontos.valor_pontos || this.pontos.valor_pontos <= 0) {
          this.$swal("Por favor informe os pontos").then(() => {
            this.$helpers.focusElement('valorPontos');
          });

          return;
        }

        this.$helpers.confirmarSenhaAdm(this, () => {
          this.load = true;

          this.$http.post('fidelidade/pontos/' + this.token, this.pontos)
            .then(res => {
              this.load = false;

              if (res.data.result) {
                this.retornoPontos = {...res.data, nome_cliente: this.pontos.nome_cliente};
                this.clientes = []
                this.pontos = {};
                this.ref_cliente = '';

                this.$nextTick(() => {
                  this.$helpers.focusElement('clienteInput');
                })

              } else if (res.data) {
                this.$swal(res.data.msg || 'Cliente não está disponível!')
              }

            }, res => {
              this.load = false;
              this.$swal(res.data.msg || 'Erro temporário');
            });
        });
      }
    },

    novoCliente() {
      this.cliente = {
        nome_cliente: '',
        telefone: this.ref_cliente,
        identificador: '',
        valor_pontos: '',
        saldo: 0,
      }

      this.menu = 3;
      this.$nextTick(() => {
        this.$helpers.focusElement('nomeCadastro');
      });
    },

    addNovoCliente() {
      if (this.load || this.cliente.telefone.length < 10) {
        this.$swal("Por favor informe um número válido de telefone.\n(DDD + Número)").then(() => {
          this.$helpers.focusElement('telefoneCadastro');
        });

        return;
      }

      this.load = true;

      this.$http.post('fidelidade/cliente/' + this.token, this.cliente)
        .then(res => {
          this.load = false;

          if (res.data.result) {
            this.toggleMenu(2);
            this.pontos = {
              id_cliente: res.data.id_cliente,
              nome_cliente: res.data.nome_cliente,
              identificador: '',
              valor_pontos: '',
              saldo: 0
            }

            this.$nextTick(() => {
              this.$helpers.focusElement('valorPontos');
            });

          } else {
            this.$swal(res.data.msg || 'Erro ao cadastrar este cliente')
          }

        }, res => {
          this.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    toggleMenu(m) {
      this.naoEncontrado = false;
      this.pontos = {};
      this.voucher = {};
      this.retornoPontos = {};
      this.clientes = [];
      this.ref_voucher = '';
      this.ref_cliente = '';
      this.cliente.nome_cliente = '';
      this.cliente.telefone = '';
      this.menu = m;

      this.$nextTick(() => {
        switch (m) {
          case 1:
            this.$helpers.focusElement('voucherInput');
            break;
          case 2:
            this.$helpers.focusElement('clienteInput');
            break;
          case 3:
            this.$helpers.focusElement('nomeCadastro');
            break;
        }
      })
    }
  },

  created() {
    this.$parent.$on('openModalFidelidade', () => {
      this.modal = true;
      this.menu = 1;
      this.ref_voucher = '';
      this.$nextTick(() => {
        this.$helpers.focusElement('voucherInput');
      })
    });
  },

  filters: {
    phone(phone) {
      if (phone) {
        if (phone.length === 10) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

        } else if (phone.length === 11) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
      }

      return phone
    },
  }
}
</script>

<style scoped>

</style>